import script from "./suerModal.vue?vue&type=script&setup=true&name=suerModal&lang=js"
export * from "./suerModal.vue?vue&type=script&setup=true&name=suerModal&lang=js"

import "./suerModal.vue?vue&type=style&index=0&id=4a3eb2bf&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a3eb2bf"]])

export default __exports__